import React, { useEffect, useRef, useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { BeheerLayout } from '../../components/beheer/BeheerLayout';
import { BeheerSection } from '../../components/beheer/BeheerSection';
import { PersonaPanel } from '../../components/beheer/anna/PersonaPanel';
import { VoicesPanel } from '../../components/beheer/anna/VoicesPanel';
import { HouseModesTable } from '../../components/beheer/anna/HouseModesTable';
import { InitiativePanel } from '../../components/beheer/anna/InitiativePanel';
import { AnnaAvatar } from '../../components/avatar/AnnaAvatar';
import { defaultHouseModes, defaultInitiative, defaultPersona, voices } from '../../data/beheer/persona';
import { db } from '../../utils/db';
export function AnnaSettings() {
  const [persona, setPersona] = useState(defaultPersona);
  const [voice, setVoice] = useState(voices[0].id);
  const [modes, setModes] = useState(defaultHouseModes);
  const [initiative, setInitiative] = useState(defaultInitiative);
  const [saved, setSaved] = useState(false);
  const first = useRef(true);

  // Settings apply immediately; one quiet confirmation and one log row per burst of changes.
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    setSaved(false);
    const id = window.setTimeout(() => {
      setSaved(true);
      db.log({
        agent: 'systeem',
        summary: 'Instellingen van Anna bijgewerkt',
        level: 'zelf',
        where: 'lokaal',
        outcome: 'uitgevoerd'
      });
    }, 700);
    return () => window.clearTimeout(id);
  }, [persona, voice, modes, initiative]);
  return <BeheerLayout title="Anna" intro="Wie Anna is: hoe ze praat, hoe ze klinkt, wat elke huismodus doet en hoeveel ze zelf onderneemt." aside={<div className="flex items-center gap-4" data-id="element-1820" data-mp="4yk9g5qwjv1q">
          {saved && <span className="flex items-center gap-1.5 text-[13px] text-ink-soft" role="status" data-id="element-1821" data-mp="3devu03e50p19">
              <CheckIcon className="h-3.5 w-3.5 text-accent" aria-hidden data-id="element-1822" data-mp="38gu9rf4z6jo7" /> Opgeslagen
            </span>}
          <div className="aspect-square w-20" aria-hidden data-id="element-1823" data-mp="1cdz1p48encaw">
            <AnnaAvatar state="rust" data-id="element-1824" data-mp="1hca8t77bf8pf" />
          </div>
        </div>} data-id="element-1819" data-mp="9rwuy70ablq9">
      <BeheerSection id="persona" title="Persoonlijkheid" className="mt-10" data-id="element-1825" data-mp="1m3iim4ck4w34">
        <PersonaPanel persona={persona} onChange={setPersona} data-id="element-1826" data-mp="1m6ejo1jpc0vs" />
      </BeheerSection>

      <div className="mt-16 grid gap-10 xl:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)]" data-id="element-1827" data-mp="1r57tnjzs59r7">
        <BeheerSection id="stemmen" title="Stem" description="Lokale stemmen draaien op Piper; de cloudstem kost per zin." data-id="element-1828" data-mp="th7hmsl1gt5s">
          <VoicesPanel selected={voice} onSelect={setVoice} data-id="element-1829" data-mp="13dkc3soerb1l" />
        </BeheerSection>
        <BeheerSection id="initiatief" title="Initiatief" description="Elke kandidaat krijgt een score. Alleen boven de drempel doet of vraagt Anna iets." data-id="element-1830" data-mp="13fnd17r3mol3">
          <InitiativePanel value={initiative} onChange={setInitiative} data-id="element-1831" data-mp="2ero62yuzwz6n" />
        </BeheerSection>
      </div>

      <BeheerSection id="modi" title="Huismodi" description="Veiligheidsmeldingen komen in elke modus door." className="mt-16" data-id="element-1832" data-mp="2iszvp4dvdkeu">
        <HouseModesTable modes={modes} onChange={next => setModes(list => list.map(m => m.mode === next.mode ? next : m))} data-id="element-1833" data-mp="7922xa1v1vjt" />
      </BeheerSection>
    </BeheerLayout>;
}